import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpService } from '../http/http.service';
import { JsonDataService } from '../commonData/json-data.service';
import { SessionStorageService } from 'ngx-webstorage';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { ErrorHandlingService } from '../error-handling/error-handling.service';
import { SessionKeys } from 'src/app/shared/enums/session-keys.enum';

@Injectable({
  providedIn: 'root'
})
export class ActivitylogService {

  isLdap: any;
  userid: any;
  username: any;

  obj_rightAssociation: any = {
    // Existing
    'pwd-policy': "Password Policy",
    'add-department': "Add Department",
    'edit-department': "Edit Department",
    'add-designation': "Add Designation",
    'edit-designation': "Edit Designation",
    'add-testtype': "Add Type of Test",
    'edit-testtype': "Edit Type of Test",
    'add-role': "Add Role",
    'edit-role': "Edit Role",
    'add-user': "Add User",
    'manage-user': "Manage User,Edit User",
    'edit-user': "Manage User,Edit User",

    'role-log': "View Audit Trail,Print Audit Trail",
    'audit-change-profile': "View Audit Trail,Print Audit Trail",
    'audit-change-password': "View Audit Trail,Print Audit Trail",
    'audit-pwd-policy': "View Audit Trail,Print Audit Trail",
    'audit-department': "View Audit Trail,Print Audit Trail",
    'audit-role': "View Audit Trail,Print Audit Trail",
    'audit-user': "View Audit Trail,Print Audit Trail",
    'audit_enquiry': "View Audit Trail,Print Audit Trail",
    'audit_customer': "View Audit Trail,Print Audit Trail",
    'audit_designation': "View Audit Trail,Print Audit Trail",
    'audit_testtype': "View Audit Trail,Print Audit Trail",
    'audit_crf':"View Audit Trail,Print Audit Trail",

    'activity-log': "Activity Log",
    'sample-list': "View Sample List",

    'Test': "Approve Initial Report,Approve Final Report,Generate Report,Report Amendment,Report Correction",
    'Test-Result': "Approve Initial Report,Report Amendment,Report Correction",
    'Test-Report': "Approve Initial Report,Approve Final Report,Generate Report,Enter ULR No in Report,Report Amendment,Report Correction",
    'manage-enquiry': "Manage Enquiry",
    'sample-verification': "Sample Approval 1,Sample Receive,Sample Approval 2",

    // ✅ Newly Added (Missing from earlier list)

    'select-all': "Select All",

    'add-unit': "Add Unit",
    'edit-unit': "Edit Unit",

    'task-list': "Lab Associate",
    'add-category': "Add Category",
    'view-category': "View Category",

    'create-crf': "Create CRF",
    'crf-approval-1': "CRF Approval 1",
    'crf-approval-2': "CRF Approval 2",

    'add-inspection-checklist': "Add Inspection Checklist",


    'add-customer': "Add Customer",
    'manage-customer': "Manage Customer",

    'add-enquiry': "Add New Enquiry",
    'allocate-test': "Allocate Test",

    'lab-associate': "Lab Associate",

    'send-report-customer': "Send Report to Customer",
    'enter-ulr-report': "Enter ULR No in Report",

    'manage-feedback-form': "Manage Feedback Form",

    'report-amendment': "Report Amendment",
    'report-corrections': "Report Corrections"
  };


  constructor(public router: Router, public http?: HttpService,
    public sessionStorage?: SessionStorageService, public jsonData?: JsonDataService,
    private errorHandling?: ErrorHandlingService
  ) {
    this.jsonData?.getValueFromJSON().then((res: any) => {
      this.isLdap = res.Ldap[0].Value;
    }).catch(err => {
      console.log(err);
      this.errorHandling?.checkError(500);
    });
  }

  getComponentAddress() {
    let str_componentName: string = "";
    str_componentName = window.location.href.split("/").slice(-1)[0];
    if (str_componentName.includes('?')) {
      str_componentName = str_componentName.split("?").slice(0)[0];
    }
    return str_componentName; // window.location.href.split("/").slice(-1)[0];
  }

  getComponentAssociationWithRights(str_compName: any) {
    const obj_rights = this.sessionStorage?.retrieve(SessionKeys.RightsArray);
    // @ts-ignore:next-line
    if (this.obj_rightAssociation[str_compName].includes(",")) {
      var rightFound = 0;
      // @ts-ignore:next-line
      this.obj_rightAssociation[str_compName].split(",").forEach((element: any) => {
        if (obj_rights.includes(element) == true) {
          rightFound = 1;
        }
      });
      return (rightFound == 1) ? true : false;

    } else {
      // @ts-ignore:next-line
      return (obj_rights.includes(this.obj_rightAssociation[str_compName]));
    }
  }

  addActivityLog(param: any, IsVerify = true) {
    if (IsVerify === true) {
      if (this.getComponentAssociationWithRights(this.getComponentAddress())) {
        this.storeActivityLog(param);
      } else {
        Swal.fire({
          title: 'Access Denied',
          text: '',
          icon: "warning",
          allowOutsideClick: false
        });
        this.router.navigate(["/home"]);
      }
    } else {
      this.storeActivityLog(param);
    }
  }


  // @ts-ignore:next-line
  storeActivityLog(param: any) {
    try {
      const Obj = this.sessionStorage?.retrieve(SessionKeys.UserObject);
      this.userid = Obj.data.UserID;
      this.username = (this.isLdap == 1) ? Obj.data.UserInitials : Obj.data.UserName;
      const data = JSON.stringify({ userid: this.userid, username: this.username, activity: param });
      this.http?.postMethod('ActivityLog/store', data).subscribe((res) => {
      }, err => {
        console.log(err);
        this.errorHandling?.checkError(err.status);
      });

    } catch (error) {
      console.log(error);
      return error;
    }
  }

}
